import { render, staticRenderFns } from "./tile.vue?vue&type=template&id=6a2664eb&scoped=true&"
import script from "./tile.vue?vue&type=script&lang=js&"
export * from "./tile.vue?vue&type=script&lang=js&"
import style0 from "./tile.vue?vue&type=style&index=0&id=6a2664eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2664eb",
  null
  
)

export default component.exports